import { render } from "./ProsesSatuan.vue?vue&type=template&id=84d6915c"
import script from "./ProsesSatuan.vue?vue&type=script&lang=js"
export * from "./ProsesSatuan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__